import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SettingsIcon } from 'components/Common';
import ImageContainer from 'components/ImageContainer';
import MediaCard from 'components/MediaCard';
import InstallButtonWithPermission from 'components/InstallButtonWithPermission';
import { SimpleRatings } from 'components/Ratings';
import PermissionWarningIcon from 'components/Permissions/WarningIcon';

import { translations } from 'i18n';
import { isiOS } from 'config';
import theme from 'themes';

import androidInstalledCheck from 'inline-icons/android-installed-check.svg';
import iOSInstalledCheck from 'inline-icons/ios-installed-check.svg';

const AppDigestItem = styled.div`
  height: 100%;
  z-index: 65535;
  ${({ theme }) =>
    isiOS
      ? `
    border-bottom: 1px solid ${theme.borderColor};
    margin-left: 20px;
  `
      : `
    border-bottom: 1px solid ${theme.borderColor};
  `}
`;

const AppDigestMediaCard = styled(MediaCard)`
  ${isiOS
    ? `
    padding: 20px;
    padding-left: 0;
  `
    : `
    padding: 15px;
  `}
`;

const AppDigestIcon = theme.AppDigestIcon;

const RightItem = styled.div`
  padding: 0 ${isiOS ? 6 : 5}px;
`;

const RightButton = styled(RightItem)`
  color: #01b1ba;
`;

const InstalledIconContainer = styled.div`
  background-image: url(${({ theme }) => theme.InstalledCheck});
  height: 16px;
  width: 18px;
  -webkit-transform: translateZ(0);
`;

const InstalledIcon = () => (
  <InstalledIconContainer
    dangerouslySetInnerHTML={{
      __html: isiOS ? iOSInstalledCheck : androidInstalledCheck
    }}
  />
);

export default class AppDigest extends Component {
  static propTypes = {
    app: PropTypes.shape(),
    showInstalled: PropTypes.bool,
    showSettings: PropTypes.bool,
    showUpdate: PropTypes.bool,
    onRemove: PropTypes.func
  };

  onRemove = (ev) => {
    const { app, onRemove } = this.props;
    if (ev) {
      ev.preventDefault();
    }
    onRemove(app);
  };

  onSettingsClick = (ev) => {
    ev.preventDefault();
    const { app } = this.props;
    app.navigateToSettings();
  };

  renderRightItem() {
    const {
      app,
      showInstalled,
      showSettings,
      showUpdate,
      showPermissionWarning
    } = this.props;
    const {
      page: {
        App: { InstallButtonState }
      }
    } = translations;

    if (showUpdate && (app.hasUpdateAvailable || app.isInstalling)) {
      const installTexts = Object.keys(InstallButtonState).reduce(
        (texts, key) => {
          texts[key] = InstallButtonState[key]();
          return texts;
        },
        {}
      );
      return (
        <RightItem>
          <InstallButtonWithPermission app={app} texts={installTexts} />
        </RightItem>
      );
    }

    if (showInstalled && app.isInstalledOrInstalling) {
      return (
        <RightButton>
          <InstalledIcon />
        </RightButton>
      );
    }

    if (showPermissionWarning && app.hasPermissionWarning) {
      return (
        <RightItem>
          <PermissionWarningIcon />
        </RightItem>
      );
    }

    if (showSettings && app.hasSettings) {
      return (
        <RightButton onClick={this.onSettingsClick}>
          <SettingsIcon />
        </RightButton>
      );
    }
  }

  render() {
    const { app } = this.props;
    const {
      page: {
        AppList: {
          Digest: { appIconAltText }
        }
      }
    } = translations;

    return (
      <AppDigestItem>
        <AppDigestMediaCard
          isPrivate={app.isPrivate}
          title={app.name}
          subtitle={app.developer.name || '\u00A0'}
          subItem={<SimpleRatings app={app} />}
          leftItem={
            <ImageContainer
              containerAttr={{
                iconPlaceholder: true,
                width: app.icon.width,
                height: app.icon.height,
                styles: AppDigestIcon
              }}
              imageAttr={{
                alt: appIconAltText(),
                src: app.icon.uri
              }}
            />
          }
          rightItem={this.renderRightItem()}
        />
      </AppDigestItem>
    );
  }
}
